import {AdminUserEngagementValue} from "@shared/api/models/query/admin-user.model";

export class AdminDashboardFilterDto {
    // Narrowed union (UNIVAPLAT-2574): enum values or `week_<n>_not_completed`
    engagement: AdminUserEngagementValue[] = [];
    role: string[] = [];
    license: string[] = [];
    careProgramme: string[] = [];
    category: string[] = [];
    organisation: number[] = [];
    service: number[] = [];
    department: number[] = [];
    status: string[] = [];
    currentWeek: number[] = [];
    includeDemo: boolean = false;
    signupDateStart: string = '';
    signupDateEnd: string = '';
    firstLoginDateStart: string = '';
    firstLoginDateEnd: string = '';
    lastLoginDateStart: string = '';
    lastLoginDateEnd: string = '';
}
